/* ============================================================
   MUNDOPELUDO! — HALLOWEEN INTERACTIVE DECORATIONS
   Flying bats · Hanging spiders · Falling particles
   October 2026
   ============================================================ */
(function () {
  'use strict';

  /* ── Bat SVG ─────────────────────────────────────────────── */
  var BAT_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 42">'
    + '<path d="M40 30 C32 18 15 13 0 22 C8 17 12 9 20 13 C24 5 32 2 40 9'
    + ' C48 2 56 5 60 13 C68 9 72 17 80 22 C65 13 48 18 40 30Z" fill="#1a0a2e"/>'
    + '<ellipse cx="40" cy="33" rx="7" ry="8" fill="#1a0a2e"/>'
    + '<circle cx="36.5" cy="30" r="2.5" fill="#ff6b35" opacity="0.95"/>'
    + '<circle cx="43.5" cy="30" r="2.5" fill="#ff6b35" opacity="0.95"/>'
    + '</svg>';

  /* ── Particles list ──────────────────────────────────────── */
  var PARTICLES = ['🎃', '👻', '🕷️', '🦇', '🌙', '⭐'];

  /* ── Cobweb SVG ──────────────────────────────────────────── */
  var COBWEB_SVG = '<svg width="160" height="160" viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg">'
    + '<g stroke="rgba(210,210,210,0.65)" stroke-width="0.8" fill="none">'
    + '<line x1="0" y1="0" x2="160" y2="0"/>'
    + '<line x1="0" y1="0" x2="115" y2="45"/>'
    + '<line x1="0" y1="0" x2="80" y2="80"/>'
    + '<line x1="0" y1="0" x2="45" y2="115"/>'
    + '<line x1="0" y1="0" x2="0" y2="160"/>'
    + '<path d="M 38 0 Q 19 19 0 38" stroke-width="0.65"/>'
    + '<path d="M 72 0 Q 36 36 0 72" stroke-width="0.65"/>'
    + '<path d="M 108 0 Q 54 54 0 108" stroke-width="0.65"/>'
    + '<path d="M 144 0 Q 72 72 0 144" stroke-width="0.65"/>'
    + '</g>'
    + '<circle cx="3" cy="3" r="4" fill="rgba(40,20,50,0.85)"/>'
    + '</svg>';

  /* ── Create cobwebs ──────────────────────────────────────── */
  function addCobwebs() {
    ['tl', 'tr'].forEach(function (side) {
      var el = document.createElement('div');
      el.className = 'hw-cobweb hw-cobweb--' + side;
      el.innerHTML = COBWEB_SVG;
      document.body.appendChild(el);
    });
  }

  /* ── Create hanging spiders ──────────────────────────────── */
  function addSpiders() {
    var positions = [14, 74];
    positions.forEach(function (pos, i) {
      var el = document.createElement('div');
      el.className = 'hw-spider';
      var h = 55 + Math.random() * 70;
      el.style.cssText = 'left:' + pos + '%;height:' + (h + 20) + 'px;'
        + 'animation-delay:' + (i * 1.3) + 's;'
        + 'animation-duration:' + (3.5 + Math.random() * 2) + 's;';
      el.innerHTML = '<div class="hw-spider__thread" style="height:' + h + 'px"></div>'
        + '<div class="hw-spider__body">🕷️</div>';
      document.body.appendChild(el);
    });
  }

  /* ── Moon ────────────────────────────────────────────────── */
  function addMoon() {
    var el = document.createElement('div');
    el.className = 'hw-moon';
    document.body.appendChild(el);
  }

  /* ── Launch a flying bat ─────────────────────────────────── */
  function launchBat() {
    var bat = document.createElement('div');
    bat.className = 'hw-bat';
    bat.innerHTML = BAT_SVG;

    var fromLeft = Math.random() > 0.5;
    var topVh   = 8 + Math.random() * 35;
    var duration = (7 + Math.random() * 7) * 1000;
    var size     = 28 + Math.random() * 24;

    bat.style.cssText = 'top:' + topVh + 'vh;'
      + (fromLeft ? 'left:-60px' : 'right:-60px') + ';'
      + 'width:' + size + 'px;opacity:0;';

    document.body.appendChild(bat);

    var startX = fromLeft ? -60 : window.innerWidth + 60;
    var endX   = fromLeft ? window.innerWidth + 60 : -60;
    var wiggleAmp = (Math.random() - 0.5) * 50;
    var t0 = null;

    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min((ts - t0) / duration, 1);
      var x = startX + (endX - startX) * p;
      var y = Math.sin(p * Math.PI * 3) * 14 + wiggleAmp * p;
      var op = p < 0.08 ? p / 0.08 : p > 0.92 ? (1 - p) / 0.08 : 0.88;
      bat.style.opacity = op;
      bat.style.transform = 'translate(' + (fromLeft ? x : x - window.innerWidth) + 'px,'
        + y + 'px) scaleX(' + (fromLeft ? 1 : -1) + ')';
      if (p < 1) { requestAnimationFrame(step); } else { bat.remove(); }
    }
    setTimeout(function () { requestAnimationFrame(step); }, 80);
  }

  /* ── Spawn a falling particle ────────────────────────────── */
  var activeParticles = 0;
  var MAX_PARTICLES   = 3;

  function spawnParticle() {
    if (activeParticles >= MAX_PARTICLES) return;
    activeParticles++;

    var el = document.createElement('div');
    el.className = 'hw-particle';
    el.textContent = PARTICLES[Math.floor(Math.random() * PARTICLES.length)];

    var x        = 5 + Math.random() * 88;
    var duration = (5 + Math.random() * 6) * 1000;
    var size     = 18 + Math.random() * 12;
    var rotDir   = (Math.random() - 0.5) * 360;

    el.style.cssText = 'left:' + x + 'vw;top:-40px;font-size:' + size + 'px;opacity:0;';
    document.body.appendChild(el);

    var t0 = null;
    function step(ts) {
      if (!t0) t0 = ts;
      var p  = Math.min((ts - t0) / duration, 1);
      var y  = p * (window.innerHeight + 80);
      var op = p < 0.1 ? p / 0.1 : p > 0.8 ? (1 - p) / 0.2 : 0.72;
      var drift = Math.sin(p * Math.PI * 4) * 28;
      el.style.opacity = op;
      el.style.transform = 'translateY(' + y + 'px) translateX(' + drift + 'px) rotate(' + (p * rotDir) + 'deg)';
      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        el.remove();
        activeParticles--;
      }
    }
    requestAnimationFrame(step);
  }

  /* ── Init ────────────────────────────────────────────────── */
  function init() {
    addCobwebs();
    addMoon();
    addSpiders();

    // First two bats after short delay
    setTimeout(launchBat, 1800);
    setTimeout(launchBat, 5000);

    // Bats every ~9s
    setInterval(function () {
      if (Math.random() > 0.25) launchBat();
    }, 9000);

    // Particles every ~3.5s
    setInterval(spawnParticle, 3500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
